var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:_vm.departamentoSlug,staticClass:"plan-vector-map",attrs:{"width":"100%","height":"320px","id":_vm.departamentoSlug}},[_c('g',{ref:"base"}),_c('g',{ref:"features"})])}
var staticRenderFns = []

export { render, staticRenderFns }